import { render, staticRenderFns } from "./findPasswd.vue?vue&type=template&id=0be32a6f&scoped=true"
import script from "./findPasswd.vue?vue&type=script&lang=js"
export * from "./findPasswd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be32a6f",
  null
  
)

export default component.exports